import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
// import './../../../characteristics/components/styles.css'
import './cliente.css';
import { TIME_SELECTION_CONTAINER } from './../../../../../constants/strings/StringsDashboard';
//import {ARMA_DROGA} from '../../../constants/icons/characteristics';
import CardFenomene from './../../../fenomene_selection/components/CardFenomene';

import ButtonBox from './ButtonBox'


class YearSelect extends Component {
    render() {
        return (
            <Grid>
                <CardFenomene
                    title={TIME_SELECTION_CONTAINER.YEAR}
                    groupbutton={
                        this.props.years.map((data, i) =>
                        <Grid  className="iconContainerFS" key={"yearselect-grid-" + i}>
                                <ButtonBox
                                    style={{ maxWidth: '80px' }}
                                    className="year"
                                    value={data.toString()}
                                    id={data}
                                    group="year"
                                />
                                
                        </Grid>   
                        )
                    }
                />
            </Grid>
        )
    }

}

export default YearSelect;
